import { render, staticRenderFns } from "./new-tris-scroll-good.vue?vue&type=template&id=a012dab0"
import script from "./new-tris-scroll-good.vue?vue&type=script&lang=js"
export * from "./new-tris-scroll-good.vue?vue&type=script&lang=js"
import style0 from "./new-tris-scroll-good.vue?vue&type=style&index=0&id=a012dab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports